import { render, staticRenderFns } from "./sianuh.vue?vue&type=template&id=7aeb2438&"
import script from "./sianuh.vue?vue&type=script&lang=js&"
export * from "./sianuh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports